export const R = {
	"title": "Velg hvem du bestiller for",
	"subtitle": "Når du velger et barn, blir barnet lagt til i profilen din, og bestillingen fortsetter.",
	"buttonCreateManually": "Legg til manuelt",
	"buttonInviteManually": "Inviter manuelt"
}